import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 667282 375454"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M10883 86796h16888v277766H10883V86796zM0 375454h38653V75913H0v299541zM656400 364562h-15318V10883h15318v353679zM630199 0v375454h37083V0h-37083zM49546 166556h569761v-10883H49546zM497312 76335l-2944 30c-64815 1403-115401 48593-117520 50595l-5339 5064 6408 3640s1992 1119 5662 2954c3229 1600 7880 3778 13533 6163h32186c-6143-1826-11746-3739-16653-5554-4121-1541-7889-3023-11255-4446-4406-1874-8184-3601-11108-5004 14906-12080 56012-41490 104331-42530l2699-29c47396 0 88631 27054 103566 38162-8822 5064-24434 13032-44472 19401h30322c9361-4230 16701-8263 21539-11109 3386-2001 5191-3238 5191-3238l5849-3984-5339-4632c-2139-1854-53176-45483-116656-45483zM49546 286038h569761v-10892H49546zM49546 240388h569761v-10882H49546zM101839 147047h143328c3425 0 6183-2767 6183-6182s-2758-6182-6183-6182H101839c-3415 0-6182 2767-6182 6182s2767 6182 6182 6182zM101839 125704h143328c3425 0 6183-2767 6183-6182s-2758-6182-6183-6182H101839c-3415 0-6182 2767-6182 6182s2767 6182 6182 6182zM101839 104351h143328c3425 0 6183-2767 6183-6182s-2758-6182-6183-6182H101839c-3415 0-6182 2767-6182 6182s2767 6182 6182 6182z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
